import Vue from "vue";
import { constants } from "@/utils/constants";

function cookiesIsExpired() {
  const expireTimeAtMs = Number(
    Vue.$cookies.get(constants.SESSION_EXPIRES)
  );

  if (!expireTimeAtMs) {
    return true;
  }

  return Date.now() > expireTimeAtMs;
}

function byPassURL(path: string) {
  const URLs = [ "/login", "/logout", "/me", "/", "", "/forgot-password", "/reset-password", ];
  return !URLs.includes(path);
}

export function sessionExpiry(path: string) {
  const isExpired = cookiesIsExpired();
  const byPassURLs = byPassURL(path);
  
  return isExpired && byPassURLs;
}